import { Component, Inject, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { mergeMap, take } from 'rxjs/operators';
import { of } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

import { AuthService } from '../../../../core/services/auth/auth.service';

import { AppConstants } from '../../../../app.constants';
import { IQRCode } from '../../../../core/models/view-models/account-models/qr-code.interface';
import { ValidateTwoFactorAuthenticationModel } from '../../../../core/models/view-models/account-models/validate-two-factor-authentication.model';
import { DisplayAccountViewModel } from '../../../../core/models/view-models/account-models/user-models/display-account-view-model.type';
import { ToastrMessageEnum } from '../../../../core/enums/toastr-messages/toastr-message.enum';

@Component({
  selector: 'app-modal-two-factor-authentication',
  templateUrl: './modal-two-factor-authentication.component.html',
  styleUrls: ['./modal-two-factor-authentication.component.scss']
})
export class ModalTwoFactorAuthenticationComponent implements OnInit {
  @Input() user: DisplayAccountViewModel;
  @Input() validationData: IQRCode;

  hidePass = true;
  qrCodePath: SafeResourceUrl;
  validateModel = new ValidateTwoFactorAuthenticationModel();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IQRCode,
    private readonly dialogRef: MatDialogRef<ModalTwoFactorAuthenticationComponent>,
    private readonly authService: AuthService,
    private readonly sanitizer: DomSanitizer,
    private readonly toastrService: ToastrService
  ) {}

  ngOnInit(): void {
    this.qrCodePath = this.sanitizer.bypassSecurityTrustResourceUrl(this.validationData.QRCode);
  }

  save() {
    this.validateModel.Email = this.user.Email;

    this.authService.validateTwoFactorAuthenticationCode(this.validateModel)
      .pipe(
        take(1),
        mergeMap(isValidated => {
          if (isValidated) {
            return this.authService.setTwoFactorEnabled(this.user.Email, true);
          }
          else {
            this.toastrService.error(
              AppConstants.INVALID_TWO_FACTOR_CODE_MESSAGE
            );
            return of();
          }
        })
      )
      .subscribe(() => {
        this.user.TwoFactorEnabled = true;
        this.dialogRef.close();

        this.toastrService.success(
          ToastrMessageEnum.TwoFactorAuthEnabledMessage,
          ToastrMessageEnum.ProfileUpdateTitle
        );
      });
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
